import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  AvaiableStockDocument,
  GetBrandsDocument,
  Product,
  useDeleteBrandMutation,
  useGetBrandsQuery,
} from '../../generated/graphql'
import { Spinner } from '../../components'
import { Button } from 'primereact/button'
import { useRef, useState, MouseEvent } from 'react'
import { Toast } from 'primereact/toast'
import { Dialog } from '../../components'
import { AddBrand } from '../../components/inventory'
import { confirmPopup } from 'primereact/confirmpopup'

const BrandList = () => {
  const { loading, data } = useGetBrandsQuery()
  const [addBrand, setAddBrand] = useState(false)
  const [product, setProduct] = useState<Product>()
  const [deleteBrand] = useDeleteBrandMutation()
  const [show, setShow] = useState(false)
  const toastSuccess = useRef<Toast>(null)
  const toastError = useRef<Toast>(null)

  const showSuccess = (message: string) => {
    if (toastSuccess && toastSuccess.current) {
      toastSuccess.current.show({
        severity: 'success',
        summary: 'Success',
        detail: message,
        life: 5000,
      })
    }
  }

  const showError = (message: string) => {
    if (toastError && toastError.current) {
      toastError.current.show({
        severity: 'error',
        summary: 'Error',
        detail: message,
        life: 5000,
      })
    }
  }

  const handleOnClickAction = (
    e: MouseEvent<HTMLButtonElement>,
    action: string,
    data: Product,
  ) => {
    if (action === 'edit') {
      setProduct(data)
      setShow(true)
    }
    if (action === 'delete') {
      confirmPopup({
        target: e.currentTarget,
        message: 'Are you sure you want to proceed?',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          const response = await deleteBrand({
            variables: { input: data.id },
            refetchQueries: [
              { query: GetBrandsDocument },
              { query: AvaiableStockDocument, variables: { input: {} } },
            ],
          })
          if (response.data?.deleteBrand.message) {
            showSuccess(response.data?.deleteBrand.message)
          } else {
            showError(response.data?.deleteBrand.errors![0].message!)
          }
        },
        reject: () => false,
      })
    }
  }

  return loading ? (
    <Spinner />
  ) : (
    <>
      <Toast ref={toastSuccess} />
      <Toast ref={toastError} />
      <Dialog
        header="Update Brand"
        visible={show}
        handleOnHide={() => setShow(false)}
      >
        <AddBrand
          hideDialog={() => setShow(false)}
          toastSuccess={showSuccess}
          toastError={showError}
          product={product}
          edit
        />
      </Dialog>
      <div className="p-col-12">
        <Button
          onClick={() => setAddBrand(true)}
          className="p-mb-2"
          type="button"
        >
          <i className="pi pi-plus p-mr-2" /> New
        </Button>
      </div>
      <Dialog
        header="Add New Brand"
        visible={addBrand}
        handleOnHide={() => setAddBrand(false)}
      >
        <AddBrand
          hideDialog={() => setAddBrand(false)}
          toastSuccess={showSuccess}
          toastError={showError}
        />
      </Dialog>
      <DataTable
        value={data?.getBrands}
        emptyMessage="No Brands"
        className="p-datatable-responsive"
      >
        <Column header="Id" body={(_: any, props: any) => props.rowIndex + 1} />
        <Column
          header="Category"
          body={(data: Product) =>
            data.categories?.map((c, i) => (
              <span key={c.id}>{`${c.name}${
                data.categories!.length - 1 !== i ? ', ' : ''
              }`}</span>
            ))
          }
        />
        <Column header="Name" field="name" />
        <Column header="Country" field="country" />
        <Column
          header="Action"
          body={(data: Product) => (
            <>
              <Button
                icon="pi pi-pencil"
                tooltip={`Edit ${data.name}`}
                tooltipOptions={{ position: 'bottom' }}
                className="p-button-text p-button-sm"
                onClick={(e: any) => handleOnClickAction(e, 'edit', data)}
                type="button"
              />
              <Button
                icon="pi pi-trash"
                tooltip={`Delete ${data.name}`}
                tooltipOptions={{ position: 'bottom' }}
                className="p-button-text p-button-sm"
                style={{ marginLeft: '1rem' }}
                onClick={(e: any) => handleOnClickAction(e, 'delete', data)}
                type="button"
              />
            </>
          )}
          headerStyle={{ width: '8em', textAlign: 'center' }}
          bodyStyle={{ textAlign: 'center', overflow: 'visible' }}
        />
      </DataTable>
    </>
  )
}

export { BrandList }
